import React, { FC, useEffect, useState } from 'react';
import {
  EditButton,
  ShowButton,
  useDataProvider,
  useNotify,
  usePermissions,
} from 'react-admin';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Dialog from '@material-ui/core/Dialog';

// import { getFieldByTitle } from '../../helpers/sortByTitle';
import { User } from '../../types/user';
import HeadTable from '../common/sortTable/sortTable';
import PaginationTable from '../common/paginationTable';
import RemoveItem from '../common/Remove/RemoveItem';
import TablesSearch from '../common/tablesSearch/tablesSearch';
import { checkPermission } from '../../helpers/checkPermissions';

import './index.css';
import BlogListTitle from '../common/listTitles/BlogListTitle';
import { getDate } from '../../helpers/dateHelper';
import { BlogPostModel } from '../../types/blogPost';
const getFieldByTitle = (title: string): string => {
  switch (title) {
    case '#':
      return '_id';
    case 'Title':
      return 'title';
    case 'Short Description':
      return 'shortDescription';
    case 'Category':
      return 'category';
    case 'Status':
      return 'status';
    case 'CreatedAt':
      return 'createdAt';
    case 'PublishAt':
      return 'publishAt';

    default:
      return title;
  }
};

const UsersList: FC = () => {
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  useEffect(() => {
    getBlogPosts('all', 1, 10, '_id', 'asc', '', '', '', '', '');
  }, []);

  const [state, setState] = useState({
    posts: Array<BlogPostModel>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: '_id',
    order: 'asc',
  });

  const [dropdown, setDropdown] = useState({
    title: false,
    first: false,
    last: false,
    email: false,
    phone: false,
    status: false,
  });

  const [filter, setFilter] = useState({
    blocked: 'all',
    searchField: '',
  });

  const [searchState, setSearchState] = useState({
    name: '',
    surname: '',
    email: '',
    phone: '',
    title: '',
  });

  const [blockedFilter, setBlockedFilter] = useState({
    with: false,
    without: false,
  });

  const [modal, setModal] = useState({
    showModal: false,
    id: '',
  });

  const getBlogPosts = async (
    blocked: string,
    page: number,
    perPage: number,
    field: string,
    order: string,
    searchName: string,
    searchSurname: string,
    searchEmail: string,
    searchPhone: string,
    searchTitle: string
  ) => {
    const users = (await dataProvider.getPosts('blogs', {
      filter: {
        // blocked: blocked,
        // searchName: searchName,
        // searchSurname: searchSurname,
        // searchEmail: searchEmail,
        // searchPhone: searchPhone,
        searchTitle: searchTitle,
      },
      pagination: { page: page, perPage: perPage },
      sort: { field: field, order: order },
    })) as any;
    setState({
      ...state,
      posts: users.data,
      total: users.total,
      page: page,
      perPage: perPage,
      field: field,
      order: order,
    });
  };

  const checkBlockedFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const discount = blockedFilter;
    discount[event.target.name] = event.target.checked;
    let currentDiscount = '';
    if (
      (discount.with && discount.without) ||
      (!discount.with && !discount.without)
    ) {
      currentDiscount = 'all';
    }
    if (discount.with && !discount.without) {
      currentDiscount = 'with';
    }
    if (!discount.with && discount.without) {
      currentDiscount = 'without';
    }
    setFilter({ ...filter, blocked: currentDiscount });
    setBlockedFilter(discount);
  };

  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };

  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: '' });
  };

  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(' ');
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };

  const handleSort = (direction: string, title: string) => {
    const field = getFieldByTitle(title);
    getBlogPosts(
      filter.blocked,
      state.page,
      state.perPage,
      field,
      direction,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getBlogPosts(
      filter.blocked,
      1,
      perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getBlogPosts(
      filter.blocked,
      page,
      state.perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const handleFirstPage = () => {
    getBlogPosts(
      filter.blocked,
      1,
      state.perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getBlogPosts(
      filter.blocked,
      newPage + 1,
      state.perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getBlogPosts(
      filter.blocked,
      1,
      10,
      '_id',
      'asc',
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const clearDiscountFilter = () => {
    setBlockedFilter({ with: false, without: false });
    setFilter({ ...filter, blocked: 'all' });
  };

  const changeStatus = async (user: User) => {
    user.isBlocked = !user.isBlocked;
    await dataProvider.update('users/cms', {
      data: user,
      id: user.id,
      previousData: {} as User,
    });
    getBlogPosts(
      filter.blocked,
      state.page,
      state.perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const applyBlockedFilter = () => {
    let blocked = '';
    if (
      (blockedFilter.with && blockedFilter.without) ||
      (!blockedFilter.with && !blockedFilter.without)
    ) {
      blocked = 'all';
    }
    if (blockedFilter.with && !blockedFilter.without) {
      blocked = 'with';
    }
    if (!blockedFilter.with && blockedFilter.without) {
      blocked = 'without';
    }
    setFilter({ ...filter, blocked: blocked });
    getBlogPosts(
      blocked,
      1,
      state.perPage,
      state.field,
      state.order,
      searchState.name,
      searchState.surname,
      searchState.email,
      searchState.phone,
      searchState.title
    );
  };

  const closeModal = () => {
    setModal({ ...modal, showModal: false, id: '' });
  };

  const openModal = (id: string) => {
    setModal({ ...modal, showModal: true, id: id });
  };

  const removeUser = async () => {
    try {
      const result = await dataProvider.delete('blogs', {
        id: modal.id,
        previousData: {} as User,
      });
      if (result.data && result.data.message) {
        closeModal();
        notify(result.data.message, 'info');
        getBlogPosts(
          filter.blocked,
          state.page,
          state.perPage,
          state.field,
          state.order,
          searchState.name,
          searchState.surname,
          searchState.email,
          searchState.phone,
          searchState.title
        );
      }
    } catch (error) {
      notify('User not found', 'error');
    }
  };

  const closeFilter = (e: any) => {
    setDropdown({
      email: false,
      first: false,
      last: false,
      phone: false,
      status: false,
      title: false,
    });
  };
  return (
    <>
      <BlogListTitle />
      <Box marginTop='0.5em'>
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Title'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.title && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'title')
                        }
                        applySearch={() => applySearch('title')}
                        searchString={searchState.title}
                        clearSearch={() => clearSearch('title')}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Category'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Short Description'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.last && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'surname')
                        }
                        applySearch={() => applySearch('surname')}
                        searchString={searchState.surname}
                        clearSearch={() => clearSearch('surname')}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Status'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.email && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'email')
                        }
                        applySearch={() => applySearch('email')}
                        searchString={searchState.email}
                        clearSearch={() => clearSearch('email')}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Show Type'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.email && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'email')
                        }
                        applySearch={() => applySearch('email')}
                        searchString={searchState.email}
                        clearSearch={() => clearSearch('email')}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='CreatedAt'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='PublishAt'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                  </TableCell>
                  <TableCell id='active-table-head-actions'>Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.posts.map((item) => {
                return (
                  <TableBody
                    key={item._id}
                    className={item._id === modal.id ? 'mark-user-row' : ''}
                    onClick={closeFilter}
                  >
                    <TableRow>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>
                        {item.category ? item.category : '-'}
                      </TableCell>
                      <TableCell>{item.shortDescription}</TableCell>
                      <TableCell>{item.status}</TableCell>
                      <TableCell>
                        {item.showHTML ? 'HTML' : 'Markdown'}
                      </TableCell>
                      <TableCell>{getDate(new Date(item.createdAt))}</TableCell>
                      <TableCell>
                        {item.publishAt
                          ? getDate(new Date(item.publishAt))
                          : '-'}
                      </TableCell>
                      <TableCell>
                        <div className='actions-table-body'>
                          <ShowButton
                            to={`blogs/${item.id}/show`}
                            id='show-post'
                          />
                          <EditButton
                            to={`blogs/${item.id}`}
                            className='edit-post'
                          />
                          <div onClick={() => openModal(item._id)}>
                            <DeleteForeverIcon className='delete-icon' />
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.posts.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title='Blog'
          />
          <Dialog fullWidth open={modal.showModal} onClose={closeModal}>
            <DialogContent>
              <RemoveItem
                closeModal={closeModal}
                removeUser={removeUser}
                mainText='Blog Post'
                minorText='All information about the post will be completely remove
                    from the system'
              />
            </DialogContent>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default UsersList;
